import { useCurrentUserContext } from '@/modules/auth/hooks/useCurrentUserContext';
import { PageHeader } from '@/modules/common/components/PageHeader';
import { UserRole } from '@/types/user';
import { List } from '@mui/icons-material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import { getRouteApi } from '@tanstack/react-router';
import { ApplicationsTab } from '../components/ApplicationsTab';
import { ApplicationsSearchParams } from '../types';

const routeApi = getRouteApi('/_admin/applications/');

export function ListApplicationPage() {
  const { currentUser, isLoading: isLoadingCurrentUser } =
    useCurrentUserContext() ?? {};
  const search = routeApi.useSearch() as ApplicationsSearchParams;
  const navigate = routeApi.useNavigate();

  if (isLoadingCurrentUser) {
    return null;
  }

  return (
    <div className="flex flex-col min-h-full">
      <PageHeader
        pageTitle={
          currentUser?.roles.includes(UserRole.TaxBenefitsProvider)
            ? 'Tax benefits applications'
            : 'Applications'
        }
      />
      <TabContext value="applications">
        <TabList
          className="flex gap-5 px-8 border-b mt-8 !overflow-visible"
          slotProps={{
            scroller: {
              className: '!overflow-visible ',
            },
          }}
        >
          <Tab
            label={
              <div className="flex gap-2 items-center">
                <List />
                Applications
              </div>
            }
            value="applications"
            onClick={() =>
              navigate({ search: { ...search, tab: 'applications' } })
            }
          />
        </TabList>

        <TabPanel
          value="applications"
          className="flex-1 px-8 pt-4 flex flex-col"
        >
          <ApplicationsTab />
        </TabPanel>
      </TabContext>
    </div>
  );
}
